export default __webpack_public_path__ + "static/media/LeftArrowPurple.fc206fde.webp";